import { Component, OnInit } from '@angular/core';
import { paths } from 'src/app/Shared/enums/paths.enum';
import { CommonService } from 'src/app/Shared/services/common_services/common.service';
import { LoaderindicatorService } from 'src/app/Shared/services/loaderindicator/loaderindicator.service';
import { DataCommunicationService } from 'src/app/Shared/services/data_service/data-communication.service';
import { TranslateService } from '@ngx-translate/core';
import { ReadingJsonService } from 'src/app/Shared/services/configuration_service/reading-json.service';
import { ModalService } from 'src/app/Shared/services';
import { PlatformLocation } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { CampaignRedirectionService } from 'src/app/Shared/services/campaign/campaign-redirection.service';
import { async } from '@angular/core/testing';

declare var gtag;
@Component({
  selector: 'app-car-list',
  templateUrl: './car-list.component.html',
  styleUrls: ['./car-list.component.css']
})
export class CarListComponent implements OnInit {

  vehicleList;
  currentData: any;
  VehilceKilometer;
  RequiredKM = false;
  vehicleSelected: any;
  selected: string = '';
  selectVehicleData: any;
  brandList: any;
  modelList: any;
  showBtn = true;
  dealerId: any;
  notSupportedModel=[];
  constructor(
    private commonService: CommonService,
    private loadingIndicatorService: LoaderindicatorService,
    private dataCommunicationService: DataCommunicationService,
    private translate: TranslateService,
    private readJsonFile: ReadingJsonService,
    private modalService: ModalService,
    private activatedRoute:ActivatedRoute,
    private campaignRedirectionService: CampaignRedirectionService
  ) {  }

  async ngOnInit() {
    this.commonService.removeLocalStorage(['serviceIDList', 'SelectedService', 'PackageServiceListData', 
    'VehileKm','isWaiting']);
    let DmsNo = this.activatedRoute.snapshot.queryParamMap.get('DMSNo')
    let CampId = this.activatedRoute.snapshot.queryParamMap.get('campId')
    let MobileNo = this.activatedRoute.snapshot.queryParamMap.get('Mobile')

    if(DmsNo != "" && DmsNo != null && CampId != "" && CampId != null && MobileNo != "" && MobileNo != null){
      this.commonService.setLocalStorage('campaignId', CampId);
      this.campaignRedirectionService.getDealerByDMSNo(DmsNo,MobileNo).then(res=>{
        this.dealerId = this.commonService.getLocalStorageitem('dealername');       
        this.getDealerBrands();
      });
    }else{
      this.dealerId = this.commonService.getLocalStorageitem('dealername');    
      this.getDealerBrands();
    }
  }

  public getDealerBrands() {
    this.dataCommunicationService.getDealerBrands
      (this.commonService.getLocalStorageitem('dealername')).subscribe(
        result => {
          this.loadingIndicatorService.hide();
          if (result.StatusCode === 1) {
            //this.brandList = result.data   
            this.brandList = result.Data.map(item => item.BrandCode).filter((value, index, self) => self.indexOf(value) === index)

            //this.getDealerModels();        
            this.getAllBrandModels();  
          } else {
            this.commonService.getErrorMessage(result.message);
          }
        }, error => {
          this.commonService.getErrorMessage('LoaderText.AlertMsg');
        }
      );
  }

  public getAllBrandModels(){
    this.dataCommunicationService.getAllBrandModels().subscribe(
        result => {
          this.loadingIndicatorService.hide();
          if (result.StatusCode === 1) {
            this.modelList = result.Data;
            //this.brandList = this.modelList.map(item => item.BrandCode).filter((value, index, self) => self.indexOf(value) === index)
            this.notSupportedModel = this.modelList.filter(x=> !x.ModelStatus);            
            this.getCustomerVehicleList();
          } else {
            this.commonService.getErrorMessage(result.message);
          }
        }, error => {
          this.commonService.getErrorMessage('LoaderText.AlertMsg');
        }
      );
  }

  public getCustomerVehicleList() {
    this.translate.get('LoaderText.loadingVechile').subscribe(message => {
      this.loadingIndicatorService.show(message);
    });
    let mobileNumber = this.commonService.getLocalStorageByKey('customerData', 'MobileNo');    
    this.dataCommunicationService.getCustomerVehicleList(mobileNumber, this.dealerId).subscribe(
        result => {
          this.loadingIndicatorService.hide();
          if (result.StatusCode === 1) {            
            this.vehicleList = result.Data;              
            this.PushDataToAnalyticsForVechileList();
            const source =  this.commonService.getLocalStorageitem("AppointmentSource");
            if(source != undefined && source != '' && source != null && source === 'mysite'){
              const Lp = this.commonService.getLocalStorageitem("SelectedVehicleLicensePlate");
                if(Lp != undefined && Lp != '' && Lp != null){
                  this.selectVehicle(this.vehicleList.find(x => x.LicensePlateNo === Lp));
                }              
            }else{
              if(this.vehicleList.length == 1){
                this.selectVehicle(this.vehicleList[0]);
              }
              //this.checkVehicleList();
            }
            
          } else {
            this.commonService.getErrorMessage(result.message);
          }
        }, error => {
          this.commonService.getErrorMessage('LoaderText.AlertMsg');
        }
      );
  }

  // private checkVehicleList() {
  //   if (this.vehicleList.length === 1) {
  //     if (this.checkVehicleExists(this.vehicleList[0])) {
  //       this.selectVehicle(this.vehicleList[0]);
  //     } else {
  //       this.PushDataToAnalyticsForSelectedService(this.vehicleList[0].BrandName + ' ' + this.vehicleList[0].ModelName, 'false');
  //       window.open(this.commonService.getReturnURL(this.vehicleList[0].BrandName, this.vehicleList[0].LicensePlateNo, this.vehicleList[0].ModelName), '_blank');
  //       this.commonService.NavigatePage(paths.BOOKAPPOINTMENT, 'Drammen');
  //     }
  //   }
  // }

  public selectVehicle(vechicleData) {
    vechicleData.ModelCode = vechicleData.ModelName;
    vechicleData.BrandCode = vechicleData.BrandName;
    this.commonService.setLocalStorage('SelectedVehicleLicensePlate', vechicleData.LicensePlateNo);      
    this.commonService.setLocalStorage('vehicleData', vechicleData);

    if (this.checkVehicleExists(vechicleData)) {
      this.commonService.removeLocalStorage(['serviceIDList', 'SelectedService', 'PackageServiceListData', 'VehileKm','SelectedEUService']);
      this.PushDataToAnalyticsForSelectedService(vechicleData.BrandName + ' ' + vechicleData.ModelName, 'true');
      this.commonService.NavigatePage(paths.CARSERVICE);

    } else {
      this.PushDataToAnalyticsForSelectedService(vechicleData.BrandName + ' ' + vechicleData.ModelName, 'false');
      window.open(this.commonService.getReturnURL(vechicleData.BrandName, vechicleData.LicensePlateNo, vechicleData.ModelName), '_blank');
      let alias = this.commonService.getLocalStorageitem('DealerAliasName')
      this.commonService.NavigatePage(paths.BOOKAPPOINTMENT, alias);
    }
  }

  

  private checkVehicleExists(vehilceData) {
    if(this.notSupportedModel.find(e =>  
      vehilceData.ModelName.toLowerCase() === e.ModelName.toLowerCase() && 
      vehilceData.BrandName.toLowerCase() === e.BrandCode.toLowerCase())){
      return false;
    }
    else if(this.brandList.find(x => x.toLowerCase() === vehilceData.BrandName.toLowerCase() ))
    {
      return true;
    }  
    return false;
  }

  public PushDataToAnalyticsForVechileList() {
    let validCar = 'false';
    for (let i = 0; i < this.vehicleList.length; i++) {      
      for (let i = 0; i < this.vehicleList.length; i++) {
        if (this.checkVehicleExists(this.vehicleList[i])) {
          validCar = 'true';
        }
      }
    }
    gtag('event', 'GetVehicles', {'so-cars': this.vehicleList.length, 'so-validCar': validCar});
  }

  public PushDataToAnalyticsForSelectedService(CarBrandModel, Value) {
    gtag('event', 'SelectVehicle', {'so-car': CarBrandModel, 'so-validCar': Value});
  }

  public CheckVechileType(vechicleData): boolean {
    if ((vechicleData.BrandName.toLowerCase() === 'mitsubishi' && vechicleData.ModelName.toLowerCase().includes('outlander'))
      || vechicleData.BrandName.toLowerCase() === 'renault' && vechicleData.ModelName.toLowerCase().includes('zoe')
      || vechicleData.BrandName.toLowerCase() === 'dacia') {
      return false;
    }
    else {
      return true;
    }
  }

  // public getDealerModels() {    
  //   this.dataCommunicationService.getDealerModels
  //     (this.commonService.getLocalStorageitem('dealername')).subscribe(
  //       result => {
  //         this.loadingIndicatorService.hide();
  //         if (result.StatusCode === 1) {
  //           this.modelList = result.Data;
  //           console.log(this.modelList)
  //           this.getCustomerVehicleList();
  //         } else {
  //           this.commonService.getErrorMessage(result.message);
  //         }
  //       }, error => {
  //         this.commonService.getErrorMessage('LoaderText.AlertMsg');
  //       }
  //     );
  // }

  public ReadJsonVehicleList() {
    this.readJsonFile.getJSONData()
      .then(data => {
        this.vehicleList = data.VechileList;        
      });
  }

  public numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  public ShowPopup(id) {
    this.isModalOpen = true;
    this.modalService.open(id);
  }

  isModalOpen = false;
  public HidePopUp(id) {
    this.isModalOpen = false;
    this.modalService.close(id);
  }
}
